import React from 'react';


const styles = {
    overflowWrap: "break-word",
    width: "350px",
    height: "auto",
    wordwrap: "break-word",
    padding: "auto"
  }

const ShortList = (props)=>(
           <div>
               <ul>
                   <li style={styles}>
                       Favourite Names<i className="far fa-star" style={{color: "red"}}/> ~ {props.favourites}</li>
                </ul>
            </div>
            )


export default ShortList;


// WEBPACK FOOTER //
// ./src/components/mainpage/box/shortList.js